import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';

export interface BulkLoadError {
  dni?: string;
  period?: string;
  fileName?: string;
  message: string;
}

@Component({
  selector: 'app-error-details-modal',
  templateUrl: './error-details-modal.component.html',
  styleUrl: './error-details-modal.component.scss',
  providers: [DialogService],
})
export class ErrorDetailsModalComponent {

  @Input() visible = false;
  @Input() message = '';
  @Input() errors: BulkLoadError[] = [];

  @Output() closeModal = new EventEmitter<void>();

  private readonly openedAt = new Date();

  close(): void {
    this.closeModal.emit();
  }

  getLogDate(): string {
    return this.openedAt.toISOString();
  }

  get maxFileNameLength(): number {
    const maxLength = Math.max(...this.errors.map(error => error.fileName?.length ?? 0));
    return maxLength;
  }

}
